import { render, staticRenderFns } from "./AppSimpleTableInput.vue?vue&type=template&id=2fba67c4&scoped=true&"
import script from "./AppSimpleTableInput.vue?vue&type=script&lang=js&"
export * from "./AppSimpleTableInput.vue?vue&type=script&lang=js&"
import style0 from "./AppSimpleTableInput.vue?vue&type=style&index=0&id=2fba67c4&lang=scss&scoped=true&"
import style1 from "./AppSimpleTableInput.vue?vue&type=style&index=1&id=2fba67c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba67c4",
  null
  
)

export default component.exports